import { parseISO } from 'date-fns'

export const UNSETTIME = parseISO('0001-01-01T00:00:00')
export const isUnsetTime = (date: Date): boolean => UNSETTIME.getTime() === date.getTime()
